export default "__VITE_ASSET__CBNFc$ki__"